import * as ReactDOM from "react-dom/client";
import App from "./App";
import { initializeTeamsApp } from "./infrastructure/teams";

// Early, non-blocking start of Teams SDK initialization — the handshake with
// the Teams host begins before React mounts the tree. We do not block rendering
// so that on a possible SDK timeout the user does not see a blank screen.
initializeTeamsApp().catch((error) => {
  console.warn("[Teams SDK] early initialize failed", error);
});

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<App />);
